import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {LoggerModule} from 'ngx-logger';
import {environment} from '../../../environments/environment';
import {SpinnerModule} from '../../components/spinner/spinner.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    LoggerModule.forRoot({level: environment.logLevel}),
    TranslateModule,
    SpinnerModule,
  ],
  exports: [
    LoggerModule,
    TranslateModule,
    SpinnerModule,
  ]
})
export class SharedModule {
}
